import { FC } from 'react';

import { CoOwner } from 'types';

import CoOwnersTableBody from './CoOwnersTableBody';
import CoOwnersTableHeader from './CoOwnersTableHeader';

type CoOwnersTableProps = {
  coOwners: CoOwner[];
  colSpan: number;
};

const CoOwnersTable: FC<CoOwnersTableProps> = ({ coOwners, colSpan }) => {
  const content = (
    <>
      <CoOwnersTableHeader />
      <CoOwnersTableBody coOwners={coOwners} />
    </>
  );

  return (
    <tr className="bg-light inner-shadow">
      <td colSpan={colSpan} className="p-0">
        <table className="w-100">{content}</table>
      </td>
    </tr>
  );
};

export default CoOwnersTable;
